module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAUBAMAAAB2TKBEAAAAAXNSR0IArs4c6QAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAd0SU1FB90CGwkKEQAi1VgAAAAZdEVYdENvbW1lbnQAQ3JlYXRlZCB3aXRoIEdJTVBXgQ4XAAAAD1BMVEUAAAAAAAFGPC/BpHb////3KtRsAAAAAXRSTlMAQObYZgAAAAFiS0dEBI9o2VEAAABUSURBVAjXjYzBEcAwCMPIBnDZACaItf9uheb6Lx90MsbMVtidIHz22tQZ2BLyVyRqtUBVrTZqlccmKdUAmYm/N+TUWnU0fZQcv33ua1QfEBfAf8ED7sURNpE8hp0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./assets/icons/strength-icon.png
// module id = 506
// module chunks = 0